import * as Yup from 'yup';

export const ConsoleFeedbackValidationSchema = Yup.object().shape({
  categoryRefValueId: Yup.number().nullable().required('Укажите категорию'),
  subject: Yup.string().nullable().max(255, 'Не более 255 символов'),
  messageBody: Yup.string().nullable().required('Укажите текст обращения').max(5000, 'Не более 5000 символов'),
});
